import HeaderLink from "../../layout/page/header/link-header";
import React, { useContext } from "react";
import { LanguageContext } from "../../../context/languageContext";
import { languages } from "../language-selection/languages";
import { useMessageSource } from "react-message-source";

function formatLanguageKey(key?: string | null) {
  const targetedLanguage = languages.find((language) => language.value === key);
  if (!targetedLanguage.textKey) {
    return "";
  }

  return targetedLanguage.textKey;
}

interface LanguageChooserProps {
  languageDrawerOpenHandler: (isDrawerOpen: boolean) => void;
}

const LanguageChooser = ({
  languageDrawerOpenHandler,
}: LanguageChooserProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { language } = useContext(LanguageContext);

  const shortLanguage = getMessage(formatLanguageKey(language)).substring(0, 2);
  const longLanguage = getMessage(formatLanguageKey(language));

  return (
    <>
      <HeaderLink
        title={longLanguage}
        className={`language-long`}
        onClick={() => languageDrawerOpenHandler(true)}
      >
        {longLanguage}
      </HeaderLink>
      <HeaderLink
        title={longLanguage}
        className={`language-short`}
        onClick={() => languageDrawerOpenHandler(true)}
      >
        {shortLanguage}
      </HeaderLink>
    </>
  );
};

export default LanguageChooser;
